import { useNavigate } from "react-router-dom";
import { alertMessage } from "./alertService";
import { ALERT_TITLES } from "../constants";

export const useErrorResponse = () => {
  const navigate = useNavigate();

  return (status: number, message: string = "") => {
    const defaultMessages: Record<number, string> = {
      400: "The request could not be understood or was missing required parameters.",
      401: "Authentication is required and has failed or has not yet been provided.",
      403: "You do not have permission to access this resource.",
      404: "The requested resource could not be found.",
      405: "The HTTP method is not supported for this resource.",
      406: "The requested format is not supported.",
      408: "The server timed out waiting for the request.",
      // 409: "The request could not be completed due to a conflict with the current state of the resource.",
      410: "The requested resource is no longer available.",
      415: "The media type is not supported.",
      422: "The request was well-formed but could not be processed due to semantic errors.",
      429: "You have sent too many requests in a given amount of time.",
      500: "An unexpected error occurred on the server.",
      501: "The server does not support the functionality required to fulfill the request.",
      502: "The server received an invalid response from the upstream server.",
      503: "The server is currently unavailable. Please try again later.",
      504: "The server did not receive a timely response from the upstream server.",
    };

    if (status === 401) {
      navigate("/unauthorized-page");
      return;
    }

    const errorMsg = defaultMessages[status] || message;
    alertMessage(ALERT_TITLES.ERROR, errorMsg);
  };
};
